exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mb-10[data-v-6d452da4]{margin-bottom:10rem}", ""]);

// exports
